module.exports = __webpack_public_path__ + "media/images/front/icon-refine-82c0b35df3266b07dc162fce998fc65e.svg";